import {HANDSET_NO_RING, HANDSET_RING} from "../constants/actionTypes";

export const handsetRingAction = () => ({
    type: HANDSET_RING
});

export const handsetNoRingAction = () => ({
    type: HANDSET_NO_RING
});